import React from 'react';
import Tile from 'src/components/Tile';
import IcoMoon from 'src/components/IcoMoon';
import { ICONS } from 'src/common/constants';
import { getRoleDisplayLabel } from 'src/common/roleRegistry/roleRegistryHelpers';

export type RoleTileSize = 'small' | 'tiny';

export interface RoleTileProps {
  role: string;
  active: boolean;
  onClick: () => void;
  size?: RoleTileSize;
}

const RoleTile = ({ role, active, onClick, size = 'small' }: RoleTileProps) => {
  return (
    <Tile
      title={getRoleDisplayLabel(role)}
      size={size}
      active={active}
      onClick={onClick}
      icon={<IcoMoon glyph={ICONS[role]} />}
    />
  );
};

export default RoleTile;
